import { getSpecificationItems } from "../../../../utils/mappers/server-to-client/utils/get-specification-items.js";
const mapServerToSpecificationsBase = (serverVariant, brand, locale) => {
  const { erpId, opcoBackendId, sku, variantTypeDetails } = serverVariant;
  let brandModel, brandModelCode, faceShape, templeColor;
  if (variantTypeDetails?.__typename === "SunglassesVariantTypeDetails" || variantTypeDetails?.__typename === "FrameVariantTypeDetails") {
    brandModel = variantTypeDetails.brandModel ?? void 0;
    brandModelCode = variantTypeDetails.brandModelCode ?? void 0;
    const faceShapeValues = variantTypeDetails.faceShape.map((faceShapeItem) => {
      const matchingLocales = faceShapeItem.displayNameAllLocales.filter((localeItem) => localeItem.locale === locale).map((localeItem) => localeItem.value).filter(Boolean);
      return matchingLocales;
    }).filter((values) => values.length > 0).flat();
    faceShape = faceShapeValues.length > 0 ? faceShapeValues.join(", ") : void 0;
    templeColor = variantTypeDetails.frameFeatures?.templeColor ?? void 0;
  }
  const serverSpecifications = {
    brand,
    erpId,
    opcoBackendId,
    sku,
    brandModel,
    brandModelCode,
    faceShape,
    templeColor
  };
  return getSpecificationItems(serverSpecifications);
};
export {
  mapServerToSpecificationsBase
};
//# sourceMappingURL=map-server-to-specifications-base.js.map
